{
  "familyId": "GET-KOMMA-PLUS",
  "questions": [
    {
      "id": "GET-KOMMA-PLUS-001",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 3,4 + 2,8?",
      "options": ["6,2", "5,12", "6,12", "7,2"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kommagetallen optellen", "content": "Tel de tienden apart op. Als je 10 of meer tienden krijgt, gaat er 1 over naar de eenheden. 4 + 8 = 12 tienden = 1 heel en 2 tienden.", "icon": "lightbulb"}}],
      "conceptId": "komma_optellen_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Kijk naar de tienden: 4 + 8 = 12 tienden. 12 tienden = 1 heel en 2 tienden — de 1 gaat over naar de eenheden. Eenheden: 3 + 2 + 1 = 6. Antwoord: 6,2. Controleer: 6,2 − 2,8 = 3,4 ✓.",
        "solutionSteps": ["Tel de tienden op: 4 + 8 = 12 tienden", "12 tienden = 1 heel + 2 tienden → schrijf 2, onthoud 1", "Tel de eenheden op: 3 + 2 + 1 (overdracht) = 6", "Antwoord: 6,2"],
        "distractorExplanations": {
          "0": "Goed! 3,4 + 2,8 = 6,2. De tienden (4 + 8 = 12) geven 1 overdracht naar de eenheden.",
          "1": "Je dacht waarschijnlijk dat 12 tienden hetzelfde is als 0,12. Maar 12 tienden = 1,2 — de 1 gaat naar de eenheden. Onthoud: 10 tienden = 1 heel, dus 12 tienden = 1 heel en 2 tienden.",
          "2": "Je dacht waarschijnlijk dat je 12 tienden gewoon achter de komma schrijft. Maar 12 tienden = 1 heel + 2 tienden. De 1 gaat naar de eenheden: 3 + 2 + 1 = 6. Antwoord: 6,2, niet 6,12. Onthoud: meer dan 9 tienden? Dan gaat er 1 over naar de eenheden.",
          "3": "Je hebt de overdracht dubbel meegeteld: 3 + 2 + 2 = 7 i.p.v. 3 + 2 + 1 = 6. De overdracht uit 12 tienden is altijd 1, niet 2 — je schrijft 2 (de tienden) en onthoudt 1 (de hele). Antwoord: 6,2."
        }
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-KOMMA-PLUS-002",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Wat is 12,75 + 3,5?",
      "options": ["16,25", "15,25", "16,125", "15,125"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Ongelijk aantal decimalen", "content": "Maak het aantal cijfers achter de komma gelijk door nullen toe te voegen. 3,5 = 3,50. Zet de getallen onder elkaar met de komma's recht.", "icon": "lightbulb"}}],
      "conceptId": "komma_optellen_honderdsten",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Maak het aantal decimalen gelijk: 3,5 = 3,50. Nu: 12,75 + 3,50. Honderdsten: 5 + 0 = 5. Tienden: 7 + 5 = 12 → schrijf 2, onthoud 1. Eenheden: 2 + 3 + 1 = 6. Tientallen: 1. Antwoord: 16,25. Controleer: 16,25 − 3,50 = 12,75 ✓.",
        "solutionSteps": ["Maak decimalen gelijk: 3,5 = 3,50", "Honderdsten: 5 + 0 = 5", "Tienden: 7 + 5 = 12 → schrijf 2, onthoud 1", "Eenheden: 2 + 3 + 1 = 6. Tientallen: 1", "Antwoord: 16,25"],
        "distractorExplanations": {
          "0": "Goed! 12,75 + 3,50 = 16,25. Let op de overdracht bij de tienden: 7 + 5 = 12.",
          "1": "Je dacht waarschijnlijk dat de overdracht van de tienden niet meegeteld hoeft te worden. Maar 7 + 5 = 12 tienden → 1 overdracht naar de eenheden. 2 + 3 + 1 = 6, niet 5. Onthoud: tel de overdracht altijd mee.",
          "2": "Je dacht waarschijnlijk dat 3,5 hetzelfde is als 3,05. Maar 3,5 = 3,50 (vijf tienden), niet 3,05 (vijf honderdsten). Onthoud: voeg een nul toe achteraan — 3,5 = 3,50.",
          "3": "Je hebt twee fouten gemaakt: de overdracht vergeten én 3,5 als 3,05 gelezen. Controleer: 3,5 = 3,50 en 7 + 5 = 12 → overdracht. Antwoord: 16,25."
        }
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-KOMMA-PLUS-003",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "multiple_choice",
      "question": "Een plank is 1,85 m lang. Je plakt er een stuk van 0,6 m aan. Hoe lang is de plank nu?",
      "options": ["2,45 m", "1,91 m", "2,45 cm", "2,51 m"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kommagetallen onder elkaar", "content": "Zet de getallen onder elkaar met de komma's recht. 1,85 + 0,60. Vul aan met nullen zodat alle getallen even lang zijn achter de komma.", "icon": "lightbulb"}}],
      "conceptId": "komma_optellen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zet de getallen onder elkaar met de komma's recht: 1,85 + 0,60. Honderdsten: 5 + 0 = 5. Tienden: 8 + 6 = 14 → schrijf 4, onthoud 1. Eenheden: 1 + 0 + 1 = 2. Antwoord: 2,45 m. Controleer: 2,45 − 0,60 = 1,85 ✓.",
        "solutionSteps": ["Maak decimalen gelijk: 0,6 = 0,60", "Honderdsten: 5 + 0 = 5", "Tienden: 8 + 6 = 14 → schrijf 4, onthoud 1", "Eenheden: 1 + 0 + 1 = 2", "Antwoord: 2,45 m"],
        "distractorExplanations": {
          "0": "Goed! 1,85 + 0,60 = 2,45 m.",
          "1": "Je dacht waarschijnlijk dat 0,6 hetzelfde is als 0,06. Maar 0,6 = 0,60 (zes tienden), niet 0,06 (zes honderdsten). 1,85 + 0,06 = 1,91, maar dat is fout. Onthoud: 0,6 = 0,60 — voeg een nul toe achteraan.",
          "2": "Je dacht waarschijnlijk dat de eenheid meter en centimeter hetzelfde zijn. Maar de maten staan al in meters: 2,45 m is correct. 2,45 cm zou veel te kort zijn voor een plank. Onthoud: kijk altijd naar de eenheid in de vraag.",
          "3": "Je dacht waarschijnlijk dat de overdracht bij de tienden anders werkt. 8 + 6 = 14 tienden → schrijf 4, onthoud 1. De eenheden worden 1 + 0 + 1 = 2, niet 3. Onthoud: de overdracht is altijd 1, niet het hele getal."
        }
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "GET-KOMMA-PLUS-004",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "fill_in",
      "question": "Wat is 0,99 + 0,01?",
      "context": null,
      "data": {
        "expectedAnswer": "1",
        "acceptedAnswers": ["1", "1,00", "1,0"],
        "placeholder": "bv. 1",
        "unit": ""
      },
      "options": [],
      "correctAnswer": "1",
      "stimulusAids": [
        {
          "type": "column",
          "data": {
            "operation": "add",
            "operand1": 0.99,
            "operand2": 0.01
          },
          "a11y": { "alt": "Kolomopzet 0,99 + 0,01 met komma's recht onder elkaar; twee opeenvolgende overdrachten leiden naar het rondste getal." }
        }
      ],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0,
            "end": 1.1,
            "step": 0.1,
            "marked": [0.99, 1],
            "highlight": [0.99, 1],
            "label": "Van 0,99 naar 1 (sprong +0,01)"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele overdracht",
            "content": "Honderdsten: 9 + 1 = 10 → schrijf 0, onthoud 1. Tienden: 9 + 0 + 1 = 10 → schrijf 0, onthoud 1. Eenheden: 0 + 0 + 1 = 1. Antwoord: 1.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_overdracht",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Tel per kolom op en verwerk de overdrachten. Honderdsten: 9 + 1 = 10 → 0 schrijven, 1 onthouden. Tienden: 9 + 0 + 1 = 10 → 0 schrijven, 1 onthouden. Eenheden: 0 + 0 + 1 = 1. Antwoord: 1. Controleer: 1 − 0,01 = 0,99 ✓.",
        "solutionSteps": [
          "Honderdsten: 9 + 1 = 10 → schrijf 0, onthoud 1",
          "Tienden: 9 + 0 + 1 = 10 → schrijf 0, onthoud 1",
          "Eenheden: 0 + 0 + 1 = 1",
          "Antwoord: 1 (dubbele overdracht)",
          "Check: 1 − 0,01 = 0,99 ✓"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-KOMMA-PLUS-005",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "fill_in",
      "question": "Wat is 4,6 + 0,25 + 1,15?",
      "context": null,
      "data": {
        "expectedAnswer": "6",
        "acceptedAnswers": ["6", "6,00", "6,0"],
        "placeholder": "Typ je antwoord",
        "unit": ""
      },
      "options": [],
      "correctAnswer": "6",
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 4,
            "end": 7,
            "min": 4,
            "max": 7,
            "step": 0.5,
            "markers": [
              { "value": 4.6, "label": "4,6", "color": "blue" },
              { "value": 4.85, "label": "+0,25", "color": "amber" },
              { "value": 6, "label": "?", "color": "green" }
            ]
          },
          "a11y": { "alt": "Getallenlijn van 4 tot 7 met 4,6 als startpunt en sprongen +0,25 en +1,15 onderweg." }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Drie getallen onder elkaar",
            "content": "Maak alle decimalen even lang: 4,60 + 0,25 + 1,15. Tel per kolom op van rechts naar links. Twee overdrachten brengen je naar een rond getal: 6.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_drie_getallen",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Schrijf 4,6 als 4,60. Honderdsten: 0 + 5 + 5 = 10 → schrijf 0, onthoud 1. Tienden: 6 + 2 + 1 + 1 = 10 → schrijf 0, onthoud 1. Eenheden: 4 + 0 + 1 + 1 = 6. Antwoord: 6. Twee overdrachten maken het een rond getal.",
        "solutionSteps": [
          "Maak decimalen gelijk: 4,6 = 4,60",
          "Honderdsten: 0 + 5 + 5 = 10 → schrijf 0, onthoud 1",
          "Tienden: 6 + 2 + 1 + 1 = 10 → schrijf 0, onthoud 1",
          "Eenheden: 4 + 0 + 1 + 1 = 6",
          "Antwoord: 6"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-KOMMA-PLUS-NS-001",
      "familyId": "GET-KOMMA-PLUS",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_optellen",
      "questionType": "number_sequence",
      "question": "Welk getal volgt? 1,2  →  1,5  →  1,8  →  ?",
      "context": null,
      "data": {
        "sequence": [1.2, 1.5, 1.8, null],
        "missingIndex": 3,
        "correctValue": 2.1,
        "correctValues": [2.1]
      },
      "options": [],
      "correctAnswer": "2,1",
      "stimulusAids": [
        {
          "type": "numberLineLeaps",
          "data": {
            "start": 1.2,
            "leaps": [
              { "size": 0.3, "label": "+ 0,3" },
              { "size": 0.3, "label": "+ 0,3" },
              { "size": 0.3, "label": "+ 0,3" }
            ],
            "hideEndValue": true,
            "label": "Elke boog is +0,3 — wat is het volgende getal?",
            "mode": "stimulus"
          },
          "a11y": { "alt": "Getallenlijn met drie zichtbare sprongen van +0,3 vanaf 1,2; de laatste landing is verborgen" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vind de stap in een reeks",
            "content": "Bereken het verschil tussen twee opeenvolgende getallen: 1,5 − 1,2 = 0,3. Tel die stap op bij het laatste getal: 1,8 + 0,3 = 2,1.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "komma_optellen_reeks_stap",
      "variantIndex": 11,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Zoek de stap: 1,5 − 1,2 = 0,3 en 1,8 − 1,5 = 0,3. De reeks gaat dus steeds 0,3 omhoog. Volgende getal: 1,8 + 0,3 = 2,1.",
        "solutionSteps": [
          "Bereken het verschil: 1,5 − 1,2 = 0,3",
          "Controleer: 1,8 − 1,5 = 0,3 ✓ (constante stap)",
          "Tel stap op bij laatste getal: 1,8 + 0,3 = 2,1",
          "Antwoord: 2,1"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}